module.exports = require("focus-trap");